export default {
    SET_USER(context,user){
        // 提交到 mutation 中的 SET_PERMISSION 函数
        context.commit("SET_USER",user);
    },
    SET_PERMISSIONKEY(context,permissionKey){
        // 提交到 mutation 中的 SET_PERMISSION 函数
        context.commit("SET_PERMISSIONKEY",permissionKey);
    }
}


// WEBPACK FOOTER //
// ./src/store/action.js